import React from 'react';

const OrderDenied = ({order, _id}) => {


    const DeniedTextCondition = () => {
        if (order.recieverStep === -1) {
            if (order.reciever === _id) {
                return (
                    <p className="mt-1 text-base text-gray-500">
                        The item you shipped did not pass our validation test. The item will be returned to you.
                    </p>
                );
            }
            else {
                return (
                    <p className="mt-1 text-base text-gray-500">
                        The item the other used shipped did not pass our validation test. Your item will be returned to you
                    </p>
                );
            }
        }
        else if (order.senderStep === -1) {
            if (order.reciever === _id) {
                return (
                    <p className="mt-1 text-base text-gray-500">
                        The item the other used shipped did not pass our validation test. Your item will be returned to you
                    </p>
                );
            }
            else {
                return (
                    <p className="mt-1 text-base text-gray-500">
                        The item you shipped did not pass our validation test. The item will be returned to you.
                    </p>
                );
            }
        }
    };

    return (
        <>
            {order.reciever === _id }
            <div className="bg-white min-h-full px-4 py-16 sm:px-6 sm:py-24 md:grid md:place-items-center lg:px-8">
                <div className="max-w-max mx-auto">
                    <main className="sm:flex">
                        <div className="sm:ml-6">
                            <div className="sm:border-l sm:border-gray-200 sm:pl-6">
                                <h1 className="text-4xl font-extrabold text-gray-900 tracking-tight sm:text-5xl">Order Cancelled</h1>
                                <DeniedTextCondition/>

                            </div>
                            <div className="mt-10 flex space-x-3 sm:border-l sm:border-transparent sm:pl-6">
                                <a
                                    href="/"
                                    className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                >
                                    Go back home
                                </a>
                                {/*
                            <a
                                href=""
                                className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-indigo-700 bg-indigo-100 hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                            >
                                Contact support
                            </a>
                            */}
                            </div>
                        </div>
                    </main>
                </div>
            </div>
        </>
    );
};

export default OrderDenied;
